export default "<!-- Modal content-->\n"